<template>
  <div>
    <v-row dense>
      <span class="slide">
        Note* : File size should be less than {{ sizelimit / 1000000 }}MB! and File should be in
            <span v-for="(type, index) in allowed_extensions" in :key="index">
              {{ type }}</span
            >
            Format!
      </span>
    </v-row>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-toolbar flat dense class="toolbar">
      <v-toolbar-title>Experience Details</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="instructor_experience_list"
      class="elevation-1 mytable"
      dense
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat dense color="white">
          <!-- <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          >
          </v-text-field>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn class="button" v-on="on" small
                >Add Experience Details</v-btn
              >
            </template>
            <v-card>
              <v-card-title class="toolbar">
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="organization_name"
                        label="Organization Name *"
                        placeholder="Please enter Organization Name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="organization_name"
                        label="Organization Name *"
                        placeholder="Please enter Organization Name"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-text-field
                        dense
                        type="number"
                        rounded
                        outlined
                        v-model="no_of_years"
                        label="Experience in Years *"
                        placeholder="Please enter No. of Years"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-text-field
                        dense
                        type="number"
                        rounded
                        outlined
                        v-model="no_of_years"
                        label="Experience in Years *"
                        placeholder="Please enter No. of Years"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-text-field
                        dense
                        type="number"
                        rounded
                        outlined
                        v-model="no_of_months"
                        label="Experience in Months *"
                        placeholder="Please enter No. of Months"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-text-field
                        dense
                        type="number"
                        rounded
                        outlined
                        v-model="no_of_months"
                        label="Experience in Months *"
                        placeholder="Please enter No. of Months"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="6"
                      sm="6"
                      md="6"
                      v-if="editedIndex != -1 && experience_letter != 'NA'"
                    >
                      Previous File :
                      <a :href="aws_path + experience_letter" target="_blank">
                        View</a
                      >
                    </v-col>
                    <v-col
                      cols="6"
                      sm="6"
                      md="6"
                      v-if="editedIndex != -1 && approval_letter != 'NA'"
                    >
                      Previous File :
                      <a :href="aws_path + approval_letter" target="_blank">
                        View</a
                      >
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-file-input
                        rounded
                        label="Experience Letter"
                        outlined
                        dense
                        placeholder="Optional"
                        v-model="experience_letter"
                        @change="validateExperienceLetter()"
                        :hint="experience_letter == null ? 'File should be in given format' : 'File selected'"
                      ></v-file-input>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-file-input
                        rounded
                        label="Experience Letter"
                        outlined
                        dense
                        placeholder="Optional"
                        v-model="edit_experience_letter"
                        @change="validateEditExperienceLetter()"
                        :hint="edit_experience_letter == null ? 'File should be in given format' : 'File selected'"
                      ></v-file-input>
                    </v-col>
                    
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-file-input
                        rounded
                        label="Approval Letter"
                        outlined
                        dense
                        placeholder="Optional"
                        v-model="approval_letter"
                        @change="validateApprovalLetter()"
                        :hint="approval_letter == null ? 'File should be in given format' : 'File selected'"
                      ></v-file-input>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-file-input
                        rounded
                        label="Approval Letter"
                        outlined
                        dense
                        placeholder="Optional"
                        v-model="edit_approval_letter"
                        @change="validateEditApprovalLetter()"
                        :hint="edit_approval_letter == null ? 'File should be in given format' : 'File selected'"
                      ></v-file-input>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        :items="experience_type_list"
                        item-text="experiencetype"
                        item-value="exp_type_id"
                        v-model="experiencetype"
                        label="Experience Type *"
                        placeholder="Select Experience Type"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        :items="experience_type_list"
                        item-text="experiencetype"
                        v-model="experiencetype"
                        label="Experience Type *"
                        placeholder="Select Experience Type"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-checkbox
                        v-model="iscurrentjob"
                        label="isCurrentJob"
                        color="success"
                        hide-details
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-checkbox
                        v-model="iscurrentjob"
                        label="isCurrentJob"
                        color="success"
                        hide-details
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="button" @click="close">Cancel</v-btn>
                <v-btn class="button" @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:[`item.iscurrentjob`]="{ item }">
        <span v-if="item.iscurrentjob">
          <v-icon class="mr-2 v-icon-size" color="success"
            >mdi-check-circle-outline</v-icon
          >
        </span>
        <span v-else>
          <v-icon class="mr-2 v-icon-size" color="error"
            >mdi-close-circle-outline</v-icon
          >
        </span>
      </template>

      <template v-slot:[`item.experience_letter`]="{ item }">
        <span v-if="item.experience_letter != 'NA'">
          <a :href="aws_path + item.experience_letter" target="_blank"> View</a>
        </span>
        <span v-else> NA </span>
      </template>

      <template v-slot:[`item.approval_letter`]="{ item }">
        <span v-if="item.approval_letter != 'NA'">
          <a :href="aws_path + item.approval_letter" target="_blank"> View </a>
        </span>
        <span v-else> NA </span>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <div>
          <v-avatar style="" size="20" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
              >edit</v-icon
            >
          </v-avatar>
          <v-avatar style="" size="20" class="edit-avatar">
            <v-icon
              color="error"
              class="delete-v-icon mr-2"
              @click="deleteItem(item)"
              >delete</v-icon
            >
          </v-avatar>
        </div>
      </template>
    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="text-center">
      <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please wait..
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  props: {
    instid: Number,
  },
  data() {
    return {
      overlay: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search: "",
      dialog: false,
      dialog_upload: false,
      errorMsg: {
        organization_name: false,
      },
      headers: [
        {
          text: "Sr. No.",
          align: "left",
          sortable: false,
          value: "srno",
        },

        {
          text: "Organization Name",
          align: "left",
          sortable: false,
          value: "organization_name",
        },
        {
          text: "No. of Years",
          align: "left",
          sortable: true,
          value: "no_of_years",
        },
        {
          text: "No. of Months",
          align: "left",
          sortable: true,
          value: "no_of_months",
        },
        {
          text: "Is Current Job",
          align: "left",
          sortable: true,
          value: "iscurrentjob",
        },
        {
          text: "Experience Type",
          align: "left",
          sortable: true,
          value: "experiencetype",
        },
        {
          text: "Experience Letter",
          align: "left",
          value: "experience_letter",
        },
        {
          text: "Approval Letter",
          align: "left",
          value: "approval_letter",
        },
        { text: "Actions", value: "action", sortable: false },
      ],
      editedIndex: -1,
      instructor_experience_list: [],
      experience_type_list: [],
      organization_name: null,
      experiencetype: null,
      no_of_years: null,
      no_of_months: null,
      id: null,
      iscurrentjob: false,
      experience_letter: null,
      edit_experience_letter: null,
      approval_letter: null,
      edit_approval_letter: null,
      aws_path: null,
      sizelimit: null,
      privious_exp_letter: null,
      privious_app_letter: null,
      allowed_extensions: [],
      size_flag:false,
      ext_flag:false,
      display_size:null,
    };
  },
  watch: {
    instid() {
      this.getData();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Experience Details"
        : "Edit Experience Details";
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const formData = {
        instid: this.instid,
      };
      axios
        .post("/EmployeeProfile/getEmployeeExperience", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            this.instructor_experience_list =
              res.data.instructor_experience_list;
            this.allowed_extensions = res.data.allowed_extensions;
            this.sizelimit = res.data.sizelimit;
            this.display_size = this.sizelimit/1000
            this.aws_path = res.data.aws_path;
            this.experience_type_list = res.data.experience_type_list;
          } else {
            // alert("Somthing went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar(
                "#b71c1c",
                "Something went wrong!!!"
              );
          // alert("Somthing went wrong!!!");
        })
        .finally(() => {
          // this.comp_load = false;
        });
    },

    validateExperienceLetter() {
      let file1 = this.experience_letter;
      let file_size = file1.size;
      let file_name = this.experience_letter.name;
      let ext = file_name.split(".").pop();
      if (file_size > this.sizelimit) {
        this.size_flag = true;
        this.showSnackbar(
                "#b71c1c",
                "File should be less than " + this.sizelimit/1000000 +"MB!!!"
              );
        this.experience_letter = null;
      } else {
        this.size_flag = false;
      }
      for (var i = 0; i < this.allowed_extensions.length; i++) {
        if (ext == this.allowed_extensions[i]) {
          this.ext_flag = false;
          return;
        }
      }
      for (var i = 0; i < this.allowed_extensions.length; i++) {
        if (ext != this.allowed_extensions[i]) {
          this.ext_flag = true;
          this.showSnackbar(
                "#b71c1c",
                "File should be in " + this.allowed_extensions +" format!!!"
              );
          this.experience_letter = null;
          return;
        }
      }
    },
    validateEditExperienceLetter() {
      let file1 = this.edit_experience_letter;
      let file_size = file1.size;
      let file_name = this.edit_experience_letter.name;
      let ext = file_name.split(".").pop();
      if (file_size > this.sizelimit) {
        this.size_flag = true;
        this.showSnackbar(
                "#b71c1c",
                "File should be less than " + this.sizelimit/1000000 +"MB!!!"
              );
        this.edit_experience_letter = null;
      } else {
        this.size_flag = false;
      }
      for (var i = 0; i < this.allowed_extensions.length; i++) {
        if (ext == this.allowed_extensions[i]) {
          this.ext_flag = false;
          return;
        }
      }
      for (var i = 0; i < this.allowed_extensions.length; i++) {
        if (ext != this.allowed_extensions[i]) {
          this.ext_flag = true;
          this.showSnackbar(
                "#b71c1c",
                "File should be in " + this.allowed_extensions +" format!!!"
              );
          this.edit_experience_letter = null;
          return;
        }
      }
    },
    validateApprovalLetter() {
      let file1 = this.approval_letter;
      let file_size = file1.size;
      let file_name = this.approval_letter.name;
      let ext = file_name.split(".").pop();
      if (file_size > this.sizelimit) {
        this.size_flag = true;
        this.showSnackbar(
                "#b71c1c",
                "File should be less than " + this.sizelimit/1000000 +"MB!!!"
              );
        this.approval_letter = null;
      } else {
        this.size_flag = false;
      }
      for (var i = 0; i < this.allowed_extensions.length; i++) {
        if (ext == this.allowed_extensions[i]) {
          this.ext_flag = false;
          return;
        }
      }
      for (var i = 0; i < this.allowed_extensions.length; i++) {
        if (ext != this.allowed_extensions[i]) {
          this.ext_flag = true;
          this.showSnackbar(
                "#b71c1c",
                "File should be in " + this.allowed_extensions +" format!!!"
              );
          this.approval_letter = null;
          return;
        }
      }
    },
    validateEditApprovalLetter() {
      let file1 = this.edit_approval_letter;
      let file_size = file1.size;
      let file_name = this.edit_approval_letter.name;
      let ext = file_name.split(".").pop();
      if (file_size > this.sizelimit) {
        this.size_flag = true;
        this.showSnackbar(
                "#b71c1c",
                "File should be less than " + this.sizelimit/1000000 +"MB!!!"
              );
        this.edit_approval_letter = null;
      } else {
        this.size_flag = false;
      }
      for (var i = 0; i < this.allowed_extensions.length; i++) {
        if (ext == this.allowed_extensions[i]) {
          this.ext_flag = false;
          return;
        }
      }
      for (var i = 0; i < this.allowed_extensions.length; i++) {
        if (ext != this.allowed_extensions[i]) {
          this.ext_flag = true;
          this.showSnackbar(
                "#b71c1c",
                "File should be in " + this.allowed_extensions +" format!!!"
              );
          this.edit_approval_letter = null;
          return;
        }
      }
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.instructor_experience_list.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      this.organization_name = item.organization_name;
      this.experiencetype = item.experiencetype;
      this.id = item.id;
      this.iscurrentjob = item.iscurrentjob;
      this.experience_letter = item.experience_letter;
      this.approval_letter = item.approval_letter;
      this.no_of_years = item.no_of_years;
      this.no_of_months = item.no_of_months;
      this.dialog = true;
    },
    isValidated() {
      if (this.organization_name) {
        return true;
      } else {
        if (!this.organization_name) {
          this.errorMsg.organization_name = true;
        }

        return false;
      }
    }, // .....end of isValidated()
    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          if (this.organization_name == null) {
          this.showSnackbar(
                "#b71c1c",
                "Please enter Organization name!!!"
              );
              return false
        }
        else if (this.experiencetype == null) {
          this.showSnackbar(
                "#b71c1c",
                "Please select Experience type!!!"
              );
              return false
        }
        else if (this.no_of_years == null) {
          this.showSnackbar(
                "#b71c1c",
                "Please enter No. of Years Experience!!!"
              );
              return false
        }
        else if (this.no_of_months == null) {
          this.showSnackbar(
                "#b71c1c",
                "Please enter No. of Months Experience!!!"
              );
              return false
        }else{
          this.dialog_upload = true
          let formData = new FormData();
          formData.append("instid", this.instid);
          formData.append("organization_name", this.organization_name);
          formData.append("experiencetype", this.experiencetype);
          formData.append("id", this.id);
          formData.append("iscurrentjob", this.iscurrentjob);
          formData.append("experience_letter", this.edit_experience_letter);
          formData.append("approval_letter", this.edit_approval_letter);
          formData.append("no_of_years", this.no_of_years);
          formData.append("no_of_months", this.no_of_months);
          axios
            .post("/EmployeeProfile/editEmployeeExperience", formData)
            .then((res) => {
              if (res.data.msg == "200") {
                this.showSnackbar(
                  "#4caf50",
                  "Experience details updated successfully..."
                ); // show snackbar on success
                this.getData();
                this.dialog_upload = false
              }
            })
            .catch((error) => {
              this.showSnackbar(
                "#b71c1c",
                "Something went wrong!!!"
              );
              window.console.log(error);
            })
            .finally(() => {
              this.organization_name = null;
              this.experiencetype = null;
              this.iscurrentjob = null;
              this.experience_letter = null;
              this.edit_experience_letter = null;
              this.edit_approval_letter = null;
              this.no_of_months = null;
              this.no_of_years = null;
            });

          this.close();
        }
      }
      } else {
        if (this.organization_name == null) {
          this.showSnackbar(
                "#b71c1c",
                "Please enter Organization name!!!"
              );
              return false
        }
        else if (this.experiencetype == null) {
          this.showSnackbar(
                "#b71c1c",
                "Please select Experience type!!!"
              );
              return false
        }
        else if (this.no_of_years == null) {
          this.showSnackbar(
                "#b71c1c",
                "Please enter No. of Years Experience!!!"
              );
              return false
        }
        else if (this.no_of_months == null) {
          this.showSnackbar(
                "#b71c1c",
                "Please enter No. of Months Experience!!!"
              );
              return false
        }else{
          this.dialog_upload = true
        let formData = new FormData();
        formData.append("instid", this.instid);
        formData.append("organization_name", this.organization_name);
        formData.append("experiencetype", this.experiencetype);
        formData.append("id", this.id);
        formData.append("iscurrentjob", this.iscurrentjob);
        formData.append("experience_letter", this.experience_letter);
        formData.append("approval_letter", this.approval_letter);
        formData.append("no_of_years", this.no_of_years);
        formData.append("no_of_months", this.no_of_months);
        axios
          .post("/EmployeeProfile/saveEmployeeExperience", formData)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.showSnackbar(
                "#4caf50",
                "Experience details added successfully..."
              ); // show snackbar on success
              this.getData();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar(
                "#b71c1c",
                "Experience details already present!!!"
              ); // show snackbar on error
            }
            this.dialog_upload = false
          })
          .catch((error) => {
            this.showSnackbar(
                "#b71c1c",
                "Something went wrong!!!"
              );
            window.console.log(error);
          })
          .finally(() => {
            this.organization_name = null;
            this.experiencetype = null;
            this.iscurrentjob = null;
            this.experience_letter = null;
            this.approval_letter = null;
            this.no_of_months = null;
            this.no_of_years = null;
          });

        this.close();
        }
      }
    },

    deleteItem(item) {
      // alert("in delete : " + item.id);
      var result = confirm("Want to delete?");
      if (result) {
        this.dialog_upload = true
        const formData = {
          instid: this.instid,
          inst_experience_id: item.id,
        };
        axios
          .post("/EmployeeProfile/deleteEmployeeExperience", formData)
          .then((res) => {
            if (res.data.msg == "200") {
              if (res.data.status.code == "SUCCESS") {
                this.showSnackbar(
                  "#4caf50",
                  " Experience details deleted successfully..."
                );
              } else {
                this.showSnackbar(
                  "#b71c1c",
                  "Can not delete Experience details!!!"
                );
              }
              this.getData();
              this.dialog_upload = false
            } else {
              this.showSnackbar("#b71c1c", "Please try again!!!");
            }
          })
          .catch((error) => {
            this.showSnackbar(
                "#b71c1c",
                "Something went wrong!!!"
              );
            // alert("Somthing went wrong!!!");
          })
          .finally(() => {
            // this.comp_load = false;
          });
      }
    },
    close() {
      this.dialog = false;
      this.organization_name = null;
      this.experiencetype = null;
      this.iscurrentjob = null;
      this.experience_letter = null;
      this.approval_letter = null;
      this.no_of_months = null;
      this.no_of_years = null;
      this.editedIndex = -1;
      // setTimeout(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem);
      //   this.editedIndex = -1;
      // }, 300);
    },
  },
};
</script>
<style scoped>
.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
  font-size: 80%;
}

</style>